export class Bericht {
  constructor(readonly author: string,
              readonly text: string,
              readonly image: string,
              readonly date: string) {}
}
